"use client";

import Link from "next/link";
import { usePathname } from "next/navigation";
import { useEffect, useState, Suspense } from "react";
import "./Breadcrumbs.css";
import Cookies from "js-cookie";
import { getProfile } from '@/profiles/getProfile'
import { BreadcrumbSiteBaseUrl } from './BreadcrumbSiteBaseUrl';

const locales = [
  "en-US",
  "nl-NL",
  "en-GB",
  "fr-FR",
  "de-DE",
  "ja-JP",
  "pt-BR",
  "es-ES",
];

export interface BreadcrumbsProps {
  siteName: string;
  isArticlePage?: boolean;
  langCode?: string;
  noPadding?: boolean;
}

export default function Breadcrumbs({
  siteName,
  isArticlePage,
  langCode,
  noPadding = false,
}: BreadcrumbsProps) {
  const pathname = usePathname();
  const [prevPath, setPrevPath] = useState<string | null>(null);

  const [breadcrumbItem, setBreadcrumbItem] = useState<string | any>('/');
  const CookieValue = Cookies?.get('breadcrumbPreviousPage');

  const segments = pathname.split("/").filter(Boolean);
  const locale = locales.includes(segments[0]) ? segments[0] : "";
  const pathSegments = locale ? segments.slice(1) : segments;

  useEffect(() => {
    if (typeof window !== "undefined") {
      const stored = sessionStorage.getItem("previousPath");
      setPrevPath(stored);
    }
  }, []);

  // Start with the homepage
  const breadcrumbs = [
    {
      label: siteName,
      href: `/${locale}`,
    },
  ];

const normalizePath = (path: string) => {
  const parts = path.split("/").filter(Boolean);
  const normalized = locales.includes(parts[0]) ? parts.slice(1) : parts;
  return "/" + normalized.join("/");
};

const currentNormalized = normalizePath(pathname);
const previousNormalized = prevPath ? normalizePath(prevPath) : null;

if (
  isArticlePage &&
  previousNormalized &&
  previousNormalized !== currentNormalized &&
  previousNormalized.startsWith(`/tags/`)
) {
  const prevSegments = prevPath!.split("/").filter(Boolean);
  const isLocale = locales.includes(prevSegments[0]);
  const adjustedSegments = isLocale ? prevSegments.slice(1) : prevSegments;

  if (adjustedSegments[0] === "category" && adjustedSegments[1]) {
    breadcrumbs.push({
      label: adjustedSegments[1]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase()),
      href: `/${locale}/tags/${adjustedSegments[1]}`,
    });
  } else if (adjustedSegments.length > 0) {
    breadcrumbs.push({
      label: adjustedSegments[0]
        .replace(/-/g, " ")
        .replace(/\b\w/g, (l) => l.toUpperCase()),
      href: `/${locale}/${adjustedSegments[0]}`,
    });
  }
}

  // Add current path segments (e.g. article name)
  pathSegments.forEach((segment, idx) => {
    if (!isArticlePage && idx === pathSegments.length - 1) {
      const href = "/" + [locale, ...pathSegments.slice(0, idx + 1)].join("/");

      if(segment === "tags" && pathSegments[idx + 1]) {
        breadcrumbs.push({
          label: 'tags'
            .replace(/-/g, " ")
            .replace(/\b\w/g, (l) => l.toUpperCase()),
          href: `/${locale}/tags/`,
        });
        return;
      }


      // breadcrumbs.push({
      //   label: segment
      //     .replace(/-/g, " ")
      //     .replace(/\b\w/g, (l) => l.toUpperCase()),
      //   href,
      // });
    }
  });

  const generateHomeBreadcrumbText = () => {
    if(process?.env?.NEXT_PUBLIC_PROFILE?.includes('blog')){
      return "Blog";
    } else if(process?.env?.NEXT_PUBLIC_PROFILE?.includes('resources')){
      return "Resources";
    } else {
      return "Home";
    }
  }
  
  useEffect(() => {
    if(CookieValue !== undefined && CookieValue !== null) {
      const parsedCookie = JSON.parse(CookieValue);
      setBreadcrumbItem(parsedCookie);
    }
  }, [CookieValue, pathname]);
  
  const profile = getProfile(process.env.NEXT_PUBLIC_PROFILE);
  const firstBreadcrumbLink = `${BreadcrumbSiteBaseUrl(profile)}${langCode}`;

  return (
    <Suspense fallback={""}>
      <nav aria-label="Breadcrumb" className={`flex flex-row flex-wrap t2-wrapper ${noPadding ? 't2-breadcrumbs--no-wrapper-padding' : ''}`}>
        <ol className="t2-breadcrumbs flex">
          {firstBreadcrumbLink && (
            <li className="list-none pr-2 text-mxpGray9">
              <Link href={`${firstBreadcrumbLink}`} className="text-mxpGray9 visited:text-mxpGray9 hover:text-mxpGray9 no-underline">{generateHomeBreadcrumbText()}</Link>
            </li>
          )}
          {breadcrumbItem?.text && (
            <li className="list-none pr-2 capitalize">
              <Link href={`${breadcrumbItem?.link}`} className="text-mxpGray9 visited:text-mxpGray9 hover:text-mxpGray9 no-underline">{`> ${breadcrumbItem?.text}`}</Link>
            </li>
          )}
        </ol>
        {/* <ol className="t2-breadcrumbs flex items-center space-x-1 pl-0"> */}
          {/* {breadcrumbs.map((crumb, idx) => (
            <li
              key={crumb.href}
              className="t2-breadcrumbs-item flex items-center space-x-1 list-none"
            >
              {idx > 0 && <span className="mx-1">/</span>}
              <Link
                href={crumb.href}
                className={`text-[#0063a3] underline capitalize`}
                aria-current={idx === breadcrumbs.length - 1 ? "page" : undefined}
              >
                {crumb.label}
              </Link>
            </li>
          ))} */}
        {/* </ol> */}
      </nav>
    </Suspense>
  );
}
